import { render, staticRenderFns } from "./webhook-testapi.vue?vue&type=template&id=2ade53e4&scoped=true&"
import script from "./webhook-testapi.vue?vue&type=script&lang=js&"
export * from "./webhook-testapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade53e4",
  null
  
)

export default component.exports